import { useQuery } from '@tanstack/react-query';

import ParityNotificationsService from '~/services/ParityNotificationsService';

import { parityNotificationQueryKeys } from './parityNotificationQueryKeys';

export function useGetUnsolvedLowInventoryNotifications() {
  return useQuery({
    queryKey: parityNotificationQueryKeys.unsolvedLowInventory(),
    queryFn: () => ParityNotificationsService.getUnsolvedLowInventoryNotifications(),
  });
}
